import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeofenceService } from '@app-asset-config/services/geofence.service';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-geofence-filter-select',
  templateUrl: './geofence-filter-select.component.html',
  styleUrls: ['./geofence-filter-select.component.scss'],
})
export class GeofenceFilterSelectComponent implements OnInit {
  @Input() public filterType: string;
  @Input() public preSelect: string[] = [];

  @Output() selected = new EventEmitter();

  public preSelected: string[] = [];

  constructor(public geofenceService: GeofenceService, public dataService: DataService) {}

  ngOnInit(): void {
    this.preSelected = [...this.preSelect];
  }

  onSelection(data: any) {
    let obj = {};
    obj[this.filterType] = data;

    this.selected.emit(obj);
  }

  /** START - functions related to geofenceActivities filter */
  unSelectAll() {
    this.preSelected = [];
  }

  isChecked(geofenceActivity: string) {
    return this.preSelected.includes(geofenceActivity);
  }

  onCheckboxChange(event: any, geofenceActivity: string) {
    if (event.checked) {
      if (!this.preSelected.includes(geofenceActivity)) {
        this.preSelected.push(geofenceActivity);
      }
    } else {
      const index = this.preSelected.indexOf(geofenceActivity);
      if (index > -1) {
        this.preSelected.splice(index, 1);
      }
    }
  }

  updateSelection() {
    this.selected.emit({ geofenceActivities: this.preSelected });
    this.geofenceService.pop();
  }
  /** END - functions related to geofenceActivities filter */
}
